export default __webpack_public_path__ + "static/media/new_room_3.71497d4b.png";